import React, { useEffect, useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import Header from "../Navigation/Header";


function MyAccount() {
	const userCtx = useContext(UserContext);
	const [formErrors, setFormErrors] = useState([]);
	const [error, setError] = useState("");
	const [info, setInfo] = useState("");
	const [isSubmit, setIsSubmit] = useState(false);
	const { t } = useTranslation();
	const navigate = useNavigate();
	
	useEffect(() => {
		if(!userCtx.isAuthenticated){
			navigate("/");
		}
	}, []);
	
	let first_name = "", last_name = "";
	if (userCtx) {
		let userName = userCtx.userName.split(" ");
		if (userName[0]) {
			first_name = userName[0];
		}
		if (userName[1]) {
			last_name = userName[1];
		}
	}
	const initialValues = {
		userName: userCtx.userName,
		email: userCtx.loggedInUserId,
		newPassword: "",
		passwordConfirmation: "",
		password: "",
		firstName: first_name,
		lastName: last_name
	};
	const [formValues, setFormValues] = useState(initialValues);

	return (
		<>
			<Header />
			<div id="page">
				<div className="page-inner">
					<div id="main">
						{((formErrors && formErrors.length > 0) || error) && (
							<div id="inerrorMessage" className="errorblock">
								{((formErrors && formErrors.length > 0) || error) ? (
									formErrors.map((errorData, index) => (
										<p className="message-line">{errorData}</p>
									))
								) : ""}
								{error}
							</div>
						)}
						{(info && (
							<div style={{ backgroundColor: "#1d7d16", color: "white" }}>
								<b>{info}</b>
							</div>
						)
						)}
						<form className="simple_form" id="edit_user" accept-charset="UTF-8" >
							<div className="email">
								<label className="email" for="email"><span className="form_required">*</span>Email</label>
								<input className="string" required="required" type="email" readonly
									value={formValues.email} name="email" id="email" disabled />
							</div>
							<div className="first_name">
								<label className="string" for="first_name"><span className="form_required">*</span>First name</label>
								<input className="string" autofocus="autofocus" type="text" readonly
									value={formValues.firstName} name="firstName" id="firstName" disabled/>
							</div>
							<div className="last_name">
								<label className="string" for="last_name">Last name</label>
								<input className="string" type="text" readonly
									value={formValues.lastName} name="lastName" id="lastName" disabled/>
							</div>
							<div className="footer">
								<div id="submit-spinner"
									className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
								>
								</div>
							</div>
						</form>
						<Link className="account-mfa-link" reloadDocument to="https://idecisionsciences.awsapps.com/start#/devices" target="_blank">Multi-Factor Authentication</Link>
						<br />
						<br />
					</div>
				</div>
			</div>
		</>
	);
}

export default MyAccount;